document.addEventListener('click', function (event) {
  const target = event.target;
  const trigger =
    target instanceof Element
      ? target.closest('.grouped-products-link--product-card')
      : null;

  if (!trigger) return;

  const card = trigger.closest('.product-card');
  if (!card) return;

  const mainImage = card.querySelector('.product-card-main-image');
  if (!mainImage) return;

  const newImage = trigger.dataset.groupedImage;
  const newAlt = trigger.dataset.groupedImageAlt || '';
  const newSlideshowImages = trigger.dataset.groupedSlideshowImages || '';

  if (!newImage) return;

  mainImage.src = newImage;
  mainImage.alt = newAlt;
  mainImage.srcset = '';

  card.dataset.currentBaseImage = newImage;
  card.dataset.currentBaseAlt = newAlt;
  card.dataset.currentSlideIndex = '0';

  const dataEl = card.querySelector('.product-card__slideshow-data');

  if (dataEl && newSlideshowImages) {
    dataEl.dataset.slideshowImages = newSlideshowImages;
    dataEl.dataset.slideshowTotal = newSlideshowImages
      .split('|')
      .map((item) => item.trim())
      .filter(Boolean).length;
  }

  card.querySelectorAll('.grouped-products-link--product-card').forEach(function (btn) {
    btn.classList.remove('grouped-products-link-selected');
  });

  trigger.classList.add('grouped-products-link-selected');
});

(function () {
  if (window.productCardHoverSlideshowInit) return;
  window.productCardHoverSlideshowInit = true;

  const DESKTOP_BREAKPOINT = 768;
  const SLIDE_DURATION = 2500;
  const DESKTOP_MAX_IMAGES = 4;
  const MOBILE_MAX_IMAGES = 2;
  const SWIPE_THRESHOLD = 40;

  const activeSlideshows = new WeakMap();
  const touchState = new WeakMap();

  function isDesktop() {
    return window.innerWidth >= DESKTOP_BREAKPOINT;
  }

  function preloadImages(urls) {
    urls.forEach((url) => {
      const img = new Image();
      img.src = url;
    });
  }

  function getCardElements(card) {
    const image = card.querySelector('.product-card-main-image');
    const dataEl = card.querySelector('.product-card__slideshow-data');
    const progressItems = Array.from(
      card.querySelectorAll('.product-card__hover-progress-item')
    );

    if (!image || !dataEl) return null;

    const maxImages = isDesktop() ? DESKTOP_MAX_IMAGES : MOBILE_MAX_IMAGES;

    const images = (dataEl.dataset.slideshowImages || '')
      .split('|')
      .map((item) => item.trim())
      .filter(Boolean)
      .slice(0, maxImages);

    return { image, images, progressItems };
  }

  function resetProgress(progressItems) {
    progressItems.forEach((item) => {
      const fill = item.querySelector('.product-card__hover-progress-fill');
      if (!fill) return;
      fill.style.transition = 'none';
      fill.style.width = '0%';
    });
  }

  function setProgressState(progressItems, activeIndex) {
    progressItems.forEach((item, index) => {
      const fill = item.querySelector('.product-card__hover-progress-fill');
      if (!fill) return;
      fill.style.transition = 'none';
      fill.style.width = index < activeIndex ? '100%' : '0%';
    });
  }

  function setManualProgressState(progressItems, activeIndex) {
    progressItems.forEach((item, index) => {
      const fill = item.querySelector('.product-card__hover-progress-fill');
      if (!fill) return;
      fill.style.transition = 'none';
      fill.style.width = index === activeIndex ? '100%' : '0%';
    });
  }

  function animateProgress(progressItems, activeIndex) {
    const fill = progressItems[activeIndex]?.querySelector('.product-card__hover-progress-fill');
    if (!fill) return;

    fill.style.transition = 'none';
    fill.style.width = '0%';

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        fill.style.transition = `width ${SLIDE_DURATION}ms linear`;
        fill.style.width = '100%';
      });
    });
  }

  function stopSlideshow(card, restoreOriginal = true) {
    const state = activeSlideshows.get(card);
    if (!state) return;

    clearTimeout(state.timeoutId);

    if (restoreOriginal && state.originalSrc) {
      state.image.src = state.originalSrc;
      state.image.srcset = state.originalSrcset || '';
      card.dataset.currentSlideIndex = '0';
    }

    resetProgress(state.progressItems);
    activeSlideshows.delete(card);
  }

  function runSlide(card) {
    const state = activeSlideshows.get(card);
    if (!state) return;

    const { image, images, progressItems } = state;

    image.src = images[state.index];
    image.srcset = '';
    card.dataset.currentSlideIndex = String(state.index);

    setProgressState(progressItems, state.index);
    animateProgress(progressItems, state.index);

    state.timeoutId = setTimeout(() => {
      const latestState = activeSlideshows.get(card);
      if (!latestState) return;

      latestState.index = (latestState.index + 1) % latestState.images.length;
      runSlide(card);
    }, SLIDE_DURATION);
  }

  function startSlideshow(card) {
    if (!isDesktop()) return;
    if (activeSlideshows.has(card)) return;

    const els = getCardElements(card);
    if (!els) return;
    if (els.images.length < 2) return;

    preloadImages(els.images);

    const originalSrc =
      card.dataset.currentBaseImage ||
      els.image.currentSrc ||
      els.image.src;

    resetProgress(els.progressItems);

    activeSlideshows.set(card, {
      index: 0,
      timeoutId: null,
      image: els.image,
      images: els.images,
      progressItems: els.progressItems,
      originalSrc,
      originalSrcset: ''
    });

    runSlide(card);
  }

  function updateCardImage(card, index) {
    const els = getCardElements(card);
    if (!els) return;
    if (els.images.length < 2) return;

    const safeIndex = ((index % els.images.length) + els.images.length) % els.images.length;

    els.image.src = els.images[safeIndex];
    els.image.srcset = '';
    card.dataset.currentSlideIndex = String(safeIndex);

    setManualProgressState(els.progressItems, safeIndex);
  }

  document.querySelectorAll('.product-card--hover-slideshow').forEach((card) => {
    const img = card.querySelector('.product-card-main-image');
    if (img) {
      card.dataset.currentBaseImage = img.currentSrc || img.src;
      card.dataset.currentBaseAlt = img.alt || '';
      card.dataset.currentSlideIndex = '0';
    }

    const imageWrapper = card.querySelector('.product-card__image-wrapper');
    if (!imageWrapper) return;

    let hoverTimeout;

    imageWrapper.addEventListener('mouseenter', function () {
      if (!isDesktop()) return;

      hoverTimeout = setTimeout(() => {
        startSlideshow(card);
      }, 120);
    });

    imageWrapper.addEventListener('mouseleave', function () {
      if (!isDesktop()) return;

      clearTimeout(hoverTimeout);
      stopSlideshow(card, true);
    });

    imageWrapper.addEventListener(
      'touchstart',
      function (event) {
        if (isDesktop()) return;

        const els = getCardElements(card);
        if (!els || els.images.length < 2) return;

        const touch = event.touches[0];
        if (!touch) return;

        touchState.set(card, {
          startX: touch.clientX,
          startY: touch.clientY
        });
      },
      { passive: true }
    );

    imageWrapper.addEventListener(
      'touchend',
      function (event) {
        if (isDesktop()) return;

        const els = getCardElements(card);
        if (!els || els.images.length < 2) return;

        const state = touchState.get(card);
        if (!state) return;

        const touch = event.changedTouches[0];
        if (!touch) return;

        const deltaX = touch.clientX - state.startX;
        const deltaY = touch.clientY - state.startY;

        touchState.delete(card);

        if (Math.abs(deltaX) < SWIPE_THRESHOLD) return;
        if (Math.abs(deltaY) > Math.abs(deltaX)) return;

        const currentIndex = parseInt(card.dataset.currentSlideIndex || '0', 10);
        const nextIndex = deltaX < 0 ? currentIndex + 1 : currentIndex - 1;

        updateCardImage(card, nextIndex);
      },
      { passive: true }
    );
  });
})();